import React from 'react'
import {Route, IndexRedirect} from 'react-router'
import Loadable from 'react-loadable';
import Loading from './pages/Loading';

const Launcher = Loadable({
    loader: () => import('./pages/Launcher'),
    loading: Loading  
});

const CustomizerDesign = Loadable({
    loader: () => import('./pages/CustomizerDesign'),
    loading: Loading  
});

const Viewer = Loadable({
  loader: () => import('./pages/Viewer'),
  loading: Loading  
});

const Closed = Loadable({
  loader: () => import('./pages/Closed'),
  loading: Loading  
});


class RouteContainer extends React.Component{
    render(){
        return this.props.children;
    }
}

export const makeRoutes = () => {
  return (
    <Route path=''>
        <Route path="/" component={RouteContainer}>
          <IndexRedirect to="/customize/spec/rsc" />
          <Route path="customize/spec/:styleId" component={Launcher}/>
          <Route path="customize/design/:modelspaceId" component={CustomizerDesign}/>
          <Route path="customize/view/:modelspaceId" component={Viewer}/>
          <Route path="closed/:modelspaceId" component={Closed}/>
          {/* <Route path="test" component={Test}/> */}
        </Route>
    </Route>
  )
}

export default makeRoutes;


// WEBPACK FOOTER //
// ./src/Routes.js